import React, { useState, useContext } from 'react'
import { Input, Button, Result, Divider } from 'antd';
import {
    Link,
  } from 'react-router-dom';

import {useFetch} from '@utils'
import { appContext } from '../AppContext';

export default function ForgotPasswordPage() {

    const [doFetch] = useFetch();
    const [result, setResult] = useState(undefined)
    const [email, setEmail] = useState("");
    const [appState] = useContext(appContext);

    function onInputChange(event) {
        setEmail(event.target.value);
    }

    function onClickButton() {
        var uri_enc = encodeURIComponent(email)

        const url = `/api/Account/RequestForgotPassword?email=${uri_enc}`;

        doFetch(url)
            .then((response) => {
                if(response.isSuccess) {
                    setResult(true);
                    return;
                }
                setResult(false);
            })
    }

    if(result !== undefined) {
        return (
        <div className={"main"}>
            <img src={process.env.PUBLIC_URL + '/image/logo.png'} alt="Logo"/>
            <h2>Password reset request</h2>
            <Result
            status={result === true ? "success" : "error"}
            title="Reset email"
            subTitle={result === true ? "A password reset email has been sent. Please check your email" : "Something went wrong. Try again later or contact someone from the LarpTOM team"}
            extra={[
                <Link to={`/${appState.appName}/login`}>Login</Link>
            ]}
            />
        </div>
        )
    }

    return (
        <div className={"main"}>
        <img src={process.env.PUBLIC_URL + '/image/logo.png'} alt="Logo"/>
        <h2>Password reset request</h2>
        <p>Set your email address where to send the request to</p>
            <Input 
                placeholder="Your email"
                onChange={onInputChange}
            />
            <Button
                onClick={onClickButton}
            >
                Request password reset
            </Button>
            <Divider />
            <Link to={`/${appState.appName}/login`}>Login</Link>
        </div>
    )
}